import React from 'react';
import { GAME_TYPES_TYPE, operandIcon, GAME_TYPES_CONFIG } from '../../constants/constants';
import { View, Text, StyleSheet } from 'react-native';
import { Divider } from './Divider';
import LinearGradient from 'react-native-linear-gradient';
import { useSignedInContext } from '../../context/SignedInContext';
import { useGetJourneyGameBadgeByUserAndGameQuery } from '../../graphql/journey/getJourneyGameBadgesByUserAnGame.gql';
import { RibbonBadge } from '../../resources/svgComponents/badgeComponents/RibbonBadge';
import { TrophyBadge } from '../../resources/svgComponents/badgeComponents/TrophyBadge';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import { useGetHivesQuery } from '../screens/MyHives/useGetHivesQuery.gql';

type TGameAchievements = {
  gameType: GAME_TYPES_TYPE;
};

export default function GameAchievements(props: TGameAchievements) {
  const { gameType } = props;
  const { user } = useSignedInContext();
  const userId = user?.id ?? '';

  const { data } = useGetJourneyGameBadgeByUserAndGameQuery({
    variables: { userId, gameType },
    fetchPolicy: 'cache-and-network',
  });

  const earnedGameBadges = data?.journeyGameBadgeByUserAndGame?.earnedBadges ?? [];

  const levelBadges = earnedGameBadges
    .filter(badge => badge.type === 'Level')
    .sort((a, b) => parseInt(a.value ?? '0') - parseInt(b.value ?? '0'));

  const completeBadges = earnedGameBadges.filter(badge => badge.type === 'Complete');

  // const levelBadges = [
  //   {
  //     type: 'Level',
  //     value: '3',
  //     earnedAt: '2025-09-08T08:39:16.882Z',
  //   },
  //   {
  //     type: 'Level',
  //     value: '1',
  //     earnedAt: '2025-09-08T08:39:16.882Z',
  //   },
  //   {
  //     type: 'Level',
  //     value: '2',
  //     earnedAt: '2025-09-08T08:39:16.882Z',
  //   },
  //   {
  //     type: 'Level',
  //     value: '4',
  //     earnedAt: '2025-09-08T08:39:16.882Z',
  //   },
  // ];

  // const completeBadges = [
  //   {
  //     type: 'Complete',
  //     value: '1',
  //     earnedAt: '2025-09-08T08:39:16.882Z',
  //   },
  // ];

  const OperationIcon = operandIcon[GAME_TYPES_CONFIG[gameType].operation];
  return (
    <View style={styles.container}>
      <LinearGradient
        colors={['rgba(255, 207, 83, 0.55)', 'rgba(255, 153, 0, 0.55)']}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={styles.gradientBorder}
      >
        <View style={[styles.innerContainer, isMobile && { width: 360 }]}>
          <View style={[styles.activeTextContainer]}>
            <Text
              maxFontSizeMultiplier={1}
              style={[styles.activeText, { backgroundColor: 'transparent' }]}
            >
              {GAME_TYPES_CONFIG[gameType].operation}
            </Text>
            <Text
              maxFontSizeMultiplier={1}
              style={[styles.subText, { backgroundColor: 'transparent' }]}
            >
              {GAME_TYPES_CONFIG[gameType].name}
            </Text>

            <View pointerEvents="none" style={styles.additionalIcon}>
              <OperationIcon />
            </View>
          </View>
          {/* Render badges row */}
          <View style={styles.badgesRow}>
            {levelBadges.map((badge, idx) => (
              <RibbonBadge
                key={idx}
                number={parseInt(badge.value ?? '0')}
                height={40}
                width={28}
                numberFontSize={12}
                topNumberPos={6}
              />
            ))}
            {completeBadges.map((badge, idx) => (
              <TrophyBadge key={idx} width={32} height={40} />
            ))}
          </View>
        </View>
      </LinearGradient>
      <Divider empty height={12} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  gradientBorder: {
    borderRadius: 16,
    height: 68,
  },
  innerContainer: {
    borderRadius: 14,
    backgroundColor: '#FFF8E3',
    overflow: 'hidden',
    flexDirection: 'row',
    width: 400,
  },
  activeTextContainer: {
    position: 'relative',
    height: 60,
    justifyContent: 'center',
    borderRadius: 16,
    backgroundColor: '#FFF5DD',
    opacity: 0.8,
    overflow: 'hidden',
    flex: 1,
  },
  activeText: {
    fontFamily: 'Secular One',
    fontSize: 16,
    fontWeight: '400',
    color: '#121212',
    paddingHorizontal: 12,
    marginLeft: 55, // Space for additional icon
  },

  subText: {
    fontFamily: 'Secular One',
    fontSize: 12,
    fontWeight: '400',
    color: '#929292',
    paddingHorizontal: 12,
    marginLeft: 55, // Space for additional icon
  },
  additionalIcon: {
    position: 'absolute',
    left: 10,
  },
  badgesRow: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end', // push badges to the right
    alignItems: 'center',
    gap: 6,
    marginRight: 12,
    width: 120,
  },
});
